import React from 'react';

export default function PartnerOptionCard({ title, description, amounts = [], selected, onSelect }) {
  return (
    <div
      className={`ps-card ps-partner-card ${selected ? 'is-selected' : ''}`}
      role="button"
      tabIndex={0}
      onClick={onSelect}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect();
        }
      }}
      aria-pressed={selected}
    >
      <h3>{title}</h3>
      <p>{description}</p>
      <div className="ps-chip-row">
        {amounts.map((amount) => (
          <span key={amount} className="ps-chip">{amount}</span>
        ))}
      </div>
      <button type="button" className="btn ps-btn-outline btn-sm" onClick={onSelect}>
        Select
      </button>
    </div>
  );
}
